// eslint-disable-next-line import/no-anonymous-default-export
export default {
  common: {
    search: 'Search',
    yes: 'Yes',
    no: 'No',
    ok: 'OK',
    nok: 'NOK',
    email: 'Email address',
    cancel: 'Cancel',
    close: 'Close',
    save: 'Save',
    edit: 'Edit',
    date: 'Date',
    time: 'Time',
    date_from: 'Date from',
    date_to: 'Date to',
    today: 'Today',
    last_seven_days: 'Last 7 days',
    clear: 'Clear',
    min: 'Min',
    max: 'Max',
    export: 'Export',
    export_pdf: 'Export to PDF',
    export_excel: 'Export to Excel',
    add: 'Add',
    delete: 'Delete',
    tag: 'Tag/Attribute',
    name: 'Name',
    actions: 'Actions',
    confirm: 'Confirm',
    select: 'Select',
    selected: 'Selected {{count}} items',
    success: 'Success',
    confirm_delete_message: 'Are you sure you want to delete <0>{{name}}</0>?',
    error_name_required: 'Name is required',
    continue: 'Continue',
    kilograms: 'Kilograms',
    grams: 'Grams',
    no_tag: 'No Tag',
    active: 'Active',
    inactive: 'Inactive',
    details: 'Details',
    type: 'Type',
    print: 'Print',
    preview: 'Preview',
    start: 'Start',
    resume: 'Resume',
    redo: 'Redo',
    pause: 'Pause',
    stop: 'Stop',
    complete: 'Complete',
    choosen_items: 'selected items',
    filter: 'Filter',
    selected_label: 'Selected: {0}',
    version: 'Version',
    change: 'Change',
    settings: 'Settings',
  },
  measurements: {
    header: 'Measurements',
    empty_message: 'No measurements for the given scale',
    value: 'Value',
    time: 'Measurement time',
    table_footer: 'Showing {first} to {last} of {totalRecords} measurements',
  },
  login_page: {
    header: 'SCALESCLOUD.COM',
    subheader: 'System login',
    password: 'Password',
    login: 'Login',
    empty_email_error: 'Email address is required.',
    invalid_email_error: 'Invalid email address format.',
    password_error: 'Password is required.',
    invalid_credentials_error: 'Invalid email address and/or password.',
    other_error: 'An unexpected error occurred',
    register: 'Register',
    forgot_password: 'Forgot password?',
    no_account: "Don't have an account?",
  },
  register_dialog: {
    email: 'Email address',
    password: 'Password',
    header: 'User registration',
    set_password_header: 'Set new password',
    newsletter_option: 'Subscribe to newsletter and stay up to date with news',
    empty_email_error: 'Email is required',
    incorrect_email_error: 'Incorrect email address',
    email_already_in_use: 'The given email address is already in use',
    empty_password_error: 'Password is required',
    password_requirements_not_fulfilled_error:
      'Password must be at least 8 characters long, contain at least one digit, uppercase and lowercase letter and special character',
    confirmed_password_required: 'Password confirmation is required',
    confirmed_password_error: 'Passwords are not the same',
    register: 'Register',
    confirm_password: 'Confirm password',
    accept_terms: 'Accept terms and conditions',
    terms_required: 'Accepting terms and conditions is required',
    email_already_exists_error: 'Email address is already in use',
  },
  confirmation_dialog: {
    header: 'Registration confirmation',
    confirmation_code: 'Activation code',
    confirm: 'Confirm',
    send_again: 'Send activation code again',
    confirmation_code_required: 'Activation code is required',
    confirmation_code_error: 'Activation code is incorrect',
    confirmation_code_expired: 'Activation code has expired',
    user_not_found_error: 'User with the given email address not found',
    send_code_info:
      'An email with an activation code was sent to the email address provided during registration: <bold>{{email}}</bold>. To activate your account, enter the code below.',
  },
  password_recovery_dialog: {
    header: 'Password reset',
    description:
      "If you don't remember your password, enter the email address to which the account was registered for verification...",
  },
  confirm_password_recovery_dialog: {
    header: 'Password reset confirmation',
  },
  scale_chart: {
    header: 'Chart for scale',
    kilograms: 'Kilograms',
    last_thirty_one_days: 'Last 31 days',
  },
  changes_of_states: {
    status_start: 'Start',
    status_end: 'End',
    status: 'Status',
    state: 'State',
    value: 'Value',
    changes_of_states_list: 'State changes list',
    empty_message: 'No state change measurements',
    changes_of_states_file_name_report: 'state_changes_list_report',
    turn_on: 'On',
    turn_off: 'Off',
    toast_saved: 'Configuration successfully saved',
    positive: 'Positive',
    negative: 'Negative',
  },
  app_labels: {
    weighing_list: 'Weighing list',
    changes_of_states: 'State changes',
    scale_chart: 'Scale chart',
    config: 'Configuration',
    dosage: 'Dosage',
    main_page: 'Main page',
    scales: 'Scales',
    reports: 'Reports',
    change_of_state_report: 'State change report',
    suppliers: 'Suppliers',
    suppliers_list: 'Suppliers list',
    measurements: 'Measurements',
    scales_indications: 'Scale indications',
    auto_weighings: 'Automatic weighings',
    hosts: 'Hosts',
    io: 'I/O',
    administration: 'Administration',
    measurements_series: 'Weighing series',
    animals: 'Animals',
    scales_indications_dashboard: 'Scale indications dashboard',
    packaged_goods_control: 'Packaged goods control',
  },
  formats: {
    date_format: 'dd/MM/yyyy',
    hour_format: 'HH:mm',
    full_format: 'dd/MM/yyyy HH:mm:ss',
  },
  receptions_records: {
    kilograms: 'Kilograms',
    suppliers_list: 'Suppliers list',
    suppliers_list_report: 'suppliers_list_report',
    last_day: 'Last day',
    empty_message: 'No weighings',
    supplier_name: 'Supplier',
    receptions_number: 'Number of weighings',
    supplier_id: 'Supplier ID',
    scale_id: 'Scale ID',
  },
  dashboard: {
    header: 'Dashboard',
    description: 'Description',
    welcome: 'Welcome ',
  },
  scales_indications: {
    save_scale_indication: 'Perform weighing',
    save_scale_indication_and_print: 'Perform and print weighing',
    tare: 'Tare',
    zero: 'Zero',
    reconnect: 'Refresh connection',
    scale: 'Scale',
    available_scales: 'Available scales',
    scale_indication: 'Scale indication',
    empty_message: 'No scales selected',
    scale_id: 'Scale ID',
    selected_scales: 'Selected scales',
    no_scales_indications_config: 'No scale indications',
    date: 'Indication date',
    toast_saved: 'Scale indication successfully saved',
    toast_saved_and_printed: 'Scale indication successfully saved and printed',
    toast_zero: 'Zero command sent to scale',
    toast_tare: 'Tare command sent to scale',
    toast_reconnect: 'Connection refresh command sent to scale',
    toast_save_measurement: 'Measurement command sent to scale',
    toast_save_measurement_and_print: 'Measurement and print command sent to scale',
    success: 'Success',
    success_details: 'Command was executed correctly',
    error: 'Error',
    errors: {
      TIMEOUT: 'Scale response timeout exceeded',
      CONNECTION_REFUSED: 'Failed to establish connection with scale',
      SCALE_NOT_FOUND: 'No active connection with the given scale exists',
      INVALID_RESPONSE: 'Scale did not respond correctly to command',
      UNKNOWN_ERROR: 'Unknown error',
      SERVER_TIMEOUT: 'Host response timeout exceeded',
    },
  },
  weighings_list: {
    header: 'Weighings list',
    scale: 'Scale',
    indication: 'Indication',
    alibi: 'Alibi',
    select_tag: 'Select Tag/Attribute',
    selected_tags: 'Selected tags',
    weighings_list_report: 'weighings_list_report',
    empty_message: 'No weighings',
    delete_info: 'Scale indication successfully deleted',
    print: 'Printing completed successfully',
    confirm_delete_message: 'Are you sure you want to delete scale indication from <0>{{date}}</0>?',
    total_count: 'Number of weighings',
    total_mass: 'Total mass',
  },
  auto_weighings: {
    header: 'Automatic weighings',
    second: 'Second',
    minute: 'Minute',
    hour: 'Hour',
    day: 'Day',
    month: 'Month',
    interval_unit: 'Interval unit',
    interval_unit_value: 'Interval value',
    start_from: 'Start from',
    turn_on: 'Turn on',
    turn_off: 'Turn off',
    no_data: 'No automatic weighings',
    unsaved_changes: 'Warning! You have unsaved changes, are you sure you want to leave this page?',
    header_change_of_state: 'State change configuration',
    positive_state: 'Positive state change',
    negative_state: 'Negative state change',
    time_interval: 'Time interval',
    select_time_interval: 'Select time interval',
    two_minutes: 'Two minutes',
    five_minutes: 'Five minutes',
    ten_minutes: 'Ten minutes',
    min_indication_change: 'Minimum indication change',
    max_acceptable_deviation: 'Maximum acceptable deviation',
    min_indication_change_required: 'Minimum indication change is required',
    max_acceptable_deviation_required: 'Maximum acceptable deviation is required',
    config_enabled: 'Configuration enabled',
    toast_saved: 'Automatic weighings configuration successfully saved',
    toast_added: 'Automatic weighing configuration successfully added',
    toast_deleted: 'Automatic weighing configuration successfully deleted',
    auto_weighings_info: 'Automatic weighings configuration',
  },
  scales: {
    header: 'Scales',
    description: 'Description',
    empty_message: 'No scales matching the given criteria.',
    scale_details: 'Scale details',
    error_name_already_taken: 'A scale with the given name already exists.',
    error_ip_address_already_taken: 'A scale with the given IP address and port for this host already exists.',
    error_port_path_already_taken: 'A scale with the given port for this host already exists.',
    error_different_host: 'Associated devices and scale must be assigned to the same host.',
    host: 'Host',
    model: 'Model',
    connection_type: 'Connection type',
    communication_mode: 'Communication mode',
    ip_address: 'IP address',
    port: 'Port',
    port_path: 'Port address',
    baud_rate: 'Baud rate',
    stable_measurement_enabled: 'Enable stable measurements',
    stable_measurement_mode: 'Stable measurement mode',
    stable_measurement_source: 'Stable measurement source',
    stable_measurement_tolerance: 'Stable measurement tolerance',
    stable_measurement_window_ms: 'Stable measurement window (ms)',
    stable_measurement_min_count: 'Minimum number of stable measurements',
    stable_measurement_zero_value: 'Stable measurement zero value',
    hosts_empty_message: 'No active hosts in the system',
    error_model_required: 'Model is required',
    error_connection_type_required: 'Connection type is required',
    error_communication_mode_required: 'Communication mode is required',
    error_host_required: 'Host is required',
    error_invalid_ip_address: 'Invalid IP address',
    error_ip_address_required: 'IP address is required',
    error_port_required: 'Port is required',
    error_port_path_required: 'Port address is required',
    error_baud_rate_required: 'Baud rate is required',
    error_weighing_unit_required: 'Measurement unit is required',
    error_measurement_accuracy_required: 'Measurement accuracy is required',
    error_stable_measurement_mode_required: 'Stable measurement mode is required',
    error_stable_measurement_source_required: 'Stable measurement source is required',
    error_stable_measurement_tolerance_required: 'Stable measurement tolerance is required',
    error_stable_measurement_window_ms_required: 'Stable measurement window is required',
    error_stable_measurement_min_count_required: 'Minimum number of stable measurements is required',
    send_groupped: 'Group sent measurements',
    send_interval: 'Measurement sending interval (in seconds)',
    error_send_interval_required: 'Measurement sending time is required',
    weighing_unit: 'Measurement unit',
    measurement_accuracy: 'Measurement accuracy',
    measurement_regex: 'Measurement regex',
    error_measurement_regex: "Regex should contain 'measurement' group",
    toast_saved: 'Scale data successfully saved',
    toast_added: 'Scale successfully added',
    toast_deleted: 'Scale successfully deleted',
    division: 'Division',
    error_division_required: 'Division is required',
    enums: {
      TRIGGERED_BY_US: 'Querying scale for measurements',
      TRIGGERED_BY_SCALE: 'Measurements sent from scale',
    },
    printer: 'Printer',
    groups: 'Groups',
    select_groups: 'Select groups',
    error_in_use_or_multiple_dosage: 'Group has been assigned to another scale or two dosage type groups selected',
    stableMeasurementModes: {
      FIRST: 'First stable',
      MEDIAN: 'Median of stable measurements within the time window',
      LAST: 'Last stable',
    },
    stableMeasurementSources: {
      SCALE_BASED: 'Based on scale',
      CALCULATED: 'Calculated',
    },
  },
  hosts: {
    header: 'Hosts',
    description: 'Description',
    active: 'Active',
    inactive: 'Inactive',
    empty_message: 'No hosts matching the given criteria.',
    host_details: 'Host details',
    error_name_already_taken: 'A host with the given name already exists.',
    activation: 'Host activation',
    host_successfully_activated: 'Host has been successfully activated',
    code: 'Host code',
    activation_otp: 'Activation code',
    activation_code_info: 'Activation code expires after 15 minutes.',
    toast_saved: 'Host data successfully saved',
    toast_added: 'Host successfully added',
    toast_deleted: 'Host successfully deleted',
    division: 'Division',
    error_division_required: 'Division is required',
  },
  divisions: {
    header: 'Divisions',
    empty_message: 'No divisions matching the given criteria.',
    division_details: 'Division details',
    error_name_already_taken: 'A division with the given name already exists.',
    unable_delete_division: 'Division cannot be deleted.',
    members: 'Members',
    error_invalid_user: 'The provided addresses do not exist in the system',
    available_divisions: 'Available divisions',
    selected_divisions: 'Selected divisions',
  },
  hooks: {
    unsaved_changes_confirmation_message: 'You have unsaved changes. Do you want to continue?',
  },
  users: {
    header: 'Users',
    user_details: 'User details',
    email: 'Email address',
    id: 'Identifier',
    first_name: 'First name',
    last_name: 'Last name',
    role: 'Role',
    readonly: 'Read only',
    write_access: 'Write access',
    error_email_already_taken: 'A user with the given email already exists.',
    error_invalid_admin_domain: 'User in the given domain cannot be assigned to admin role',
    error_role_required: 'Select user role',
    error_email_required: 'Email is required',
    users_empty_message: 'No users matching the given criteria.',
    log_out: 'Log out',
    change_password: 'Change password',
    password: 'Password',
    password_repeat: 'Repeat password',
    old_password: 'Old password',
    password_change: 'Password change',
    password_successfully_changed: 'Password successfully changed',
    error_invalid_password: 'Invalid password',
    toast_saved: 'User data successfully saved',
    toast_added: 'User successfully added',
    toast_deleted: 'User successfully deleted',
    invalid_email_error: 'Invalid email address format.',
    language: 'Language',
    languages: {
      en: 'English',
      pl: 'Polish',
    },
  },
  measurementsSeries: {
    header: 'Weighing series',
    header_singular: 'Weighing series',
    open_header: 'Active weighing series',
    closed_header: 'Completed weighing series',
    empty_message: 'No series matching the given criteria.',
    created_at: 'Start date',
    closed_at: 'End date',
    measurements_series_details: 'Weighing series details',
    open: 'Open',
    closed: 'Closed',
    auto_measurements: 'Automatic weighing',
    begin_series: 'Start series',
    name: 'Series name',
    description: 'Series description',
    close: 'Close',
    confirm_close_message: 'Are you sure you want to close <0>{{name}}</0>?',
    series_accusative: 'series',
    auto_weighing_required: 'Automatic weighing is required',
    report_name: 'weighing_series_report',
    auto_weighing_config_tag: 'Tag',
    auto_weighing_no_data: 'No automatic weighings',
  },
  roles: {
    header: 'Roles',
    name: 'Name',
    permissions: 'Permissions',
    available: 'Available',
    selected: 'Selected',
    role_details: 'Role details',
    error_name_already_taken: 'A role with the given name already exists.',
    toast_saved: 'Role data successfully saved',
    toast_added: 'Role successfully added',
    toast_deleted: 'Role successfully deleted',
    toast_delete_error: 'Cannot delete role because it is assigned to active users',
  },
  permissions: {
    USER_MANAGEMENT: 'User management',
    ROLE_MANAGEMENT: 'Role management',
    CHANGE_CUSTOMER: 'Change customer',
    ANIMAL_MANAGEMENT: 'Animal management',
    DIVISION_MANAGEMENT: 'Division management',
    HOST_MANAGEMENT: 'Host management',
    SCALE_MANAGEMENT: 'Scale management',
    PRINTER_MANAGEMENT: 'Printer management',
    IO_MANAGEMENT: 'I/O device management',
    RAW_MATERIAL_MANAGEMENT: 'Raw material management',
    INGREDIENT_MANAGEMENT: 'Ingredient management',
    RECIPE_MANAGEMENT: 'Recipe management',
    ORDER_MANAGEMENT: 'Production order management',
    VIEW_DOSAGE_REPORTS: 'View dosage reports',
    CUSTOMER_MANAGEMENT: 'Customer management',
    GROUP_TEMPLATES_MANAGEMENT: 'Group template management',
    GROUPS_MANAGEMENT: 'I/O group management',
    LICENSE_MANAGEMENT: 'License management',
    IO_PIN_VIEW: 'I/O pin view',
    IO_PIN_EDIT: 'I/O pin edit',
    IO_PIN_EDIT_ALL: 'Edit all I/O pins',
    PRODUCT_MANAGEMENT: 'Product management',
    PACKAGED_GOODS_CONTROL_MANAGEMENT: 'Packaged Goods Control management',
    PACKAGED_GOODS_CONTROL_CHANGE_OPERATOR: 'Change packaged goods control operator',
    PACKAGED_GOODS_CONTROL_CHANGE_CONTROL: 'Change packaged goods control',
    PACKAGED_GOODS_CONTROL_CHANGE_SCALE_SETTINGS: 'Change packaged goods control scale settings',
    PACKAGED_GOODS_CONTROL_SELECT_SCALE: 'Select packaged goods control scale',
    // <%-enPermissionTranslation%>
  },
  animals: {
    header: 'Animals',
    description: 'Description',
    rfid: 'RFID',
    empty_message: 'No animals matching the given criteria.',
    animal_details: 'Animal details',
    error_name_already_taken: 'An animal with the given name already exists.',
    error_rfid_already_taken: 'An animal with the given RFID already exists.',
    division: 'Division',
    error_division_required: 'Division is required',
    error_rfid_required: 'RFID is required',
    toast_saved: 'Animal data successfully saved',
    toast_added: 'Animal successfully added',
    toast_deleted: 'Animal successfully deleted',
  },
  printers: {
    header: 'Printers',
    description: 'Description',
    empty_message: 'No printers matching the given criteria.',
    printer_details: 'Printer details',
    error_name_already_taken: 'A printer with the given name already exists.',
    connection_type: 'Connection type',
    ip_address: 'IP address',
    port: 'Port',
    port_path: 'Port address',
    baud_rate: 'Baud rate',
    databits: 'Data bits',
    stopbits: 'Stop bits',
    flow_control: 'Flow control',
    parity: 'Parity',
    product_id: 'Product identifier',
    vendor_id: 'Vendor identifier',
    division: 'Division',
    host: 'Host',
    communication_protocol: 'Communication protocol',
    zpl_content: 'ZPL script',
    hosts_empty_message: 'No active hosts in the system',
    divisions_empty_message: 'No active divisions in the system',
    error_connection_type_required: 'Connection type is required',
    error_invalid_ip_address: 'Invalid IP address',
    error_ip_address_required: 'IP address is required',
    error_port_required: 'Port is required',
    error_port_path_required: 'Port address is required',
    error_baud_rate_required: 'Baud rate is required',
    error_vendor_id_required: 'Vendor identifier is required',
    error_product_id_required: 'Product identifier is required',
    error_ip_address_already_taken: 'A printer with the given IP address and port for this host already exists.',
    error_port_path_already_taken: 'A printer with the given port for this host already exists.',
    error_vendor_id_product_id_already_taken:
      'A printer with the given vendor and product identifier for this host already exists.',
    error_different_host: 'Printer and scale must be assigned to the same host.',
    error: 'Printing error',
    errors: {
      UNKNOWN_ERROR: 'Unknown error',
      SERVER_TIMEOUT: 'Host response timeout exceeded',
      CONNECTION_ERROR: 'Failed to establish connection with printer',
      COMMUNICATION_ERROR: 'Printer did not respond correctly to command',
      COVER_IS_OPEN_ERROR: 'Paper cover is open',
      PAPER_END_ERROR: 'Out of paper',
      NOT_FOUND: 'No printer assigned to scale',
      PRINTER_NOT_FOUND: 'Printer not found',
    },
  },
  rawMaterials: {
    header: 'Raw materials',
    report_header: 'Raw materials report',
    empty_message: 'No raw materials matching the given criteria.',
    raw_material_details: 'Raw material details',
    error_name_already_taken: 'A raw material with the given name already exists.',
    usage: 'Usage',
    report_name: 'Raw material usage report',
    toast_saved: 'Raw material data successfully saved',
    toast_added: 'Raw material successfully added',
    toast_deleted: 'Raw material successfully deleted',
    connectors: 'Outputs',
    select_connectors: 'Select outputs',
  },
  ingredients: {
    header: 'Ingredients',
    empty_message: 'No ingredients matching the given criteria.',
    ingredient_details: 'Ingredient details',
    error_name_already_taken: 'An ingredient with the given name already exists.',
    raw_materials_empty_message: 'No active raw materials in the system',
    pin_number: 'Control output',
    raw_material: 'Raw material',
    error_pin_number_required: 'Control output is required',
    error_raw_material_required: 'Raw material is required',
    error_pinNumber_already_taken: 'An ingredient with the given ingredient number already exists.',
    toast_saved: 'Ingredient data successfully saved',
    toast_added: 'Ingredient successfully added',
    toast_deleted: 'Ingredient successfully deleted',
    delete_error_ingredient_in_use: 'Cannot delete ingredient because it is used in a recipe',
  },
  recipes: {
    header: 'Recipes',
    empty_message: 'No recipes matching the given criteria.',
    recipe_details: 'Recipe details',
    error_name_already_taken: 'A recipe with the given name already exists.',
    toast_saved: 'Recipe data successfully saved',
    toast_added: 'Recipe successfully added',
    toast_deleted: 'Recipe successfully deleted',
    toast_make_default: 'Recipe successfully marked as default',
    is_default: 'Default',
    makeDefault: 'Set as default',
    useActive: 'Use "Active" output',
    delayForFinished: 'Delay for "Finished" output',
  },
  recipeIngredients: {
    ingredient: 'Ingredient',
    quantity: 'Quantity',
    sequence_number: 'Sequence',
    delay: 'Delay',
    error_ingredient_required: 'Ingredient is required',
    error_quantity_required: 'Quantity is required',
    error_sequence_number_required: 'Sequence is required',
    error_sequence_number_unique: 'Sequence must be unique',
    error_sequenceNumber_already_taken: 'An ingredient with the given sequence already exists.',
    ingredients_empty_message: 'No active ingredients in the system',
  },
  orders: {
    header: 'Production orders',
    empty_message: 'No production orders matching the given criteria.',
    order_details: 'Production order details',
    error_name_already_taken: 'A production order with the given name already exists.',
    error_another_order_in_progress: 'Another production order is in progress',
    toast_added: 'Production order successfully started',
    recipe: 'Recipe',
    scale: 'Scale',
    status: 'Status',
    start_date: 'Start time',
    end_date: 'End time',
    statuses: {
      IN_PROGRESS: 'In progress',
      PAUSED: 'Paused',
      CANCELLED: 'Cancelled',
      FINISHED: 'Finished',
    },
  },
  orderIngredients: {
    order: 'Production order',
    ingredient: 'Ingredient',
    pin_number: 'Control output',
    quantity: 'Quantity',
    expected_quantity: 'Expected quantity',
    actual_quantity: 'Actual quantity',
    sequence_number: 'Sequence',
    delay: 'Delay',
  },
  customers: {
    header: 'Customers',
    empty_message: 'No customers matching the given criteria.',
    customer_details: 'Customer details',
    error_name_already_taken: 'A customer with the given name already exists.',
    first_name: 'First name',
    last_name: 'Last name',
    tax_id: 'Tax ID',
    comment: 'Comment',
    toast_saved: 'Customer data successfully saved',
    toast_added: 'Customer successfully added',
    toast_deleted: 'Customer successfully deleted',
  },
  io: {
    header: 'I/O devices',
    empty_message: 'No devices matching the given criteria.',
    io_details: 'Device details',
    error_name_already_taken: 'A device with the given name already exists.',
    error_ipAddress_already_taken: 'A device with the given IP address already exists.',
    error_division_required: 'Division is required',
    error_invalid_ip_address: 'Invalid IP address',
    error_ip_address_required: 'IP address is required',
    description: 'Description',
    host: 'Host',
    division: 'Division',
    model: 'Model',
    ip_address: 'IP address',
    hosts_empty_message: 'No active hosts in the system',
    toast_saved: 'Device data successfully saved',
    toast_added: 'Device successfully added',
    toast_deleted: 'Device successfully deleted',
  },
  groupTemplates: {
    header: 'I/O group templates',
    empty_message: 'No templates matching the given criteria.',
    group_template_details: 'Template details',
    group_template_params: 'Template parameters',
    error_name_already_taken: 'A template with the given name already exists.',
    division: 'Division',
    toast_saved: 'Template data successfully saved',
    toast_added: 'Template successfully added',
    toast_deleted: 'Template successfully deleted',
    connectors: 'Inputs/Outputs',
    input: 'Input',
    output: 'Output',
    error_connector_name_duplicated: 'Name must be unique',
    error_division_required: 'Division is required',
    error_outputs_required: 'Number of outputs is required',
    template_type_required: 'Template type is required',
    is_used: 'Used',
    type_THR: 'THR',
    type_dosage: 'Dosage',
    generate: 'Generate',
    outputs_count: 'Number of outputs',
    inputs_count: 'Number of inputs',
  },
  groups: {
    header: 'I/O groups',
    empty_message: 'No groups matching the given criteria.',
    group_details: 'Group details',
    error_name_already_taken: 'A group with the given name already exists.',
    division: 'Division',
    group_template: 'Group template',
    group_templates_empty_message: 'No active groups in the system',
    toast_saved: 'Group data successfully saved',
    toast_added: 'Group successfully added',
    toast_deleted: 'Group successfully deleted',
    io_device: 'I/O device',
    pin: 'Pin',
    error_division_required: 'Division is required',
    error_io_device_same_host: 'Selected I/O devices must be assigned to the same host',
    error_group_template_required: 'Group template is required',
    error_pin_in_use: 'Pin must be unique',
    error_io_device_required: 'I/O device is required',
    error_pin_required: 'Pin is required',
    connector_erors: {
      pin_invalid: 'Pin is invalid',
      pin_duplicate: 'Pin must be unique',
    },
  },
  licenses: {
    header: 'Licenses',
    empty_message: 'No licenses matching the given criteria.',
    license_details: 'License details',
    error_name_already_taken: 'A license with the given name already exists.',
    customer: 'Customer',
    type: 'Type',
    email: 'Email',
    device_key: 'Installation identifier',
    license_key: 'License key',
    version: 'Version',
    installation_name: 'Installation name',
    expiration_date: 'Expiration date',
    limits: 'Limits',
    users_number: 'Number of users',
    scales_number: 'Number of scales',
    comment: 'Comment',
    error_customer_required: 'Customer is required',
    error_type_required: 'Type is required',
    error_license_key_required: 'License key is required',
    error_customers_empty_message: 'No active licenses in the system',
    error_device_key_length: 'Installation identifier must be 64 characters long',
    error_device_key_hexadecimal: 'Installation identifier must be a hexadecimal value',
    toast_saved: 'License data successfully saved',
    toast_added: 'License successfully added',
    toast_deleted: 'License successfully deleted',
    toast_copied: 'License key successfully copied to clipboard',
    copyToClipboard: 'Copy license key to clipboard',
    enums: {
      OFFLINE: 'Offline',
      ONLINE: 'Online',
    },
  },
  verifyLicenseKeyPage: {
    menuHeader: 'Update license key',
    header: 'Scalescloud Offline Key',
    invalidLicenseKeyError: 'Invalid license key',
    expiredLicenseError: 'This license has expired',
    versionMismatchError: 'This license is not intended for your application version',
    verifyKey: 'Verify key',
    showInstallationKey: 'Show installation key',
    deviceKey: 'Device key',
    copy: 'Copy',
    dataCopied: 'Copied to clipboard',
    licenseUpdated: 'License key successfully updated',
  },
  scalesIndicationsDashboard: {
    back: 'Back',
  },
  pins: {
    header: 'I/O control',
    status: 'Status',
    io_name: 'I/O device name',
    pin: 'Pin',
    empty_message: 'No I/O devices to control.',
    statuses: {
      0: 'OFF',
      1: 'ON',
      ERROR: 'ERROR',
      TIMEOUT: 'IO NO RESPONSE',
      SERVER_TIMEOUT: 'HOST NO RESPONSE',
    },
    pin_toggled: 'Pin state successfully changed to ',
    pin_toggle_error: 'Error changing pin state',
  },
  scaleInfo: {
    header: 'Control Panel',
    scale_name: 'Scale Name',
    operator_name: 'Operator Name',
    timestamp: 'Timestamp',
    value: 'Value',
    no_measurements: 'No measurements available',
    operator_assigned_successfully: 'Operator assigned successfully',
    packaged_goods_control_assigned_successfully: 'Packaged Goods Control assigned successfully',
    operator_unassigned_successfully: 'Operator unassigned successfully',
    packaged_goods_control_unassigned_successfully: 'Packaged Goods Control unassigned successfully',
    current_operator: 'Operator',
    current_packaged_goods_control: 'Packaged Goods Control',
    assign_operator: 'Assign Operator',
    operator: 'Operator',
    assign_packaged_goods_control: 'Assign Packaged Goods Control',
    packaged_goods_control: 'Packaged Goods Control',
    stable_measurement_job: 'Send Stable Measurements',
    make_measurement: 'Make Measurement',
    current_indication: 'Current Indication',
    t1_error_count: 'T1 Error Count',
    t2_error_count: 'T2 Error Count',
    min_acceptable_avg_value: 'Min Acceptable Avg Value (g)',
    avg_value: 'Avg Value (g)',
    status: 'Status',
    statuses: {
      OK: 'OK',
      T1_ERROR: 'Defective',
      T2_ERROR: 'Disqualifying',
    },
  },
  products: {
    header: 'Products',
    empty_message: 'No products matching the given criteria.',
    product_details: 'Product details',

    name: 'Name',
    description: 'Description',
    target_quantity: 'Target Quantity',
    unit: 'Unit',
    density_g_ml: 'Density (g/ml)',
    tare_weight_g: 'Tare weight (g)',

    error_name_required: 'Name is required',
    error_target_quantity_required: 'Target Quantity is required',
    error_unit_required: 'Unit is required',

    error_name_already_taken: 'A product with the given name already exists.',

    toast_saved: 'Product data saved successfully',
    toast_added: 'Product added successfully',
    toast_deleted: 'Product deleted successfully',

    units: {
      G: 'g',
      KG: 'kg',
      ML: 'ml',
      L: 'l',
    },
  },
  packagedGoodsControls: {
    header: 'Packaged Goods Controls',
    empty_message: 'No packaged goods controls matching the given criteria.',
    packaged_goods_control_details: 'Packaged Goods Control details',

    name: 'Name',
    control_type: 'Control Type',
    product: 'Product',
    product_name: 'Product Name',
    product_quantity: 'Product Quantity',
    unit: 'Unit',
    density_g_ml: 'Density (g/ml)',
    tare_weight_g: 'Tare weight (g)',
    lot_number: 'Lot Number',
    planned_date: 'Planned Date',
    start_date: 'Start Date',
    end_date: 'End Date',
    lot_quantity: 'Lot Quantity',
    status: 'Status',
    result: 'Result',
    t1_error: 'T1 Error',
    scale: 'Scale',

    error_name_required: 'Name is required',
    error_control_type_required: 'Control Type is required',
    error_product_required: 'Product is required',
    error_lot_number_required: 'Lot Number is required',
    error_lot_quantity_required: 'Lot Quantity is required for sample control type',
    error_lot_quantity_min_100: 'Lot Quantity must be at least 100 for sample control type',
    error_status_required: 'Status is required',
    error_density_required_for_liquids: 'Density is required for liquid products (L or ML)',

    products_empty_message: 'No products matching the given criteria.',
    scales_empty_message: 'No scales matching the given criteria.',

    toast_saved: 'Packaged Goods Control data saved successfully',
    toast_added: 'Packaged Goods Control added successfully',
    toast_deleted: 'Packaged Goods Control deleted successfully',

    controlTypes: {
      FULL: 'Full',
      SAMPLE: 'Sample',
    },

    statuses: {
      PLANNED: 'Planned',
      PAUSED: 'Paused',
      IN_PROGRESS: 'In Progress',
      COMPLETED: 'Completed',
      CANCELLED: 'Cancelled',
    },
    results: {
      PASS: 'Acceptance',
      FAIL_T1: 'Rejection - too many defective items',
      FAIL_T2: 'Rejection - too many disqualifying items',
      FAIL_AVG: 'Rejection - average actual quantity too low',
    },
  },

  // <%-enTranslations%>
};
